import { render, staticRenderFns } from "./FAB.vue?vue&type=template&id=32fdc2a2&scoped=true&"
import script from "./FAB.vue?vue&type=script&lang=js&"
export * from "./FAB.vue?vue&type=script&lang=js&"
import style0 from "./FAB.vue?vue&type=style&index=0&id=32fdc2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdc2a2",
  null
  
)

export default component.exports